/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the SDExternalUserApplicationStatus
 *
 * @class SDExternalUserApplicationStatus
 */
class SDExternalUserApplicationStatus {
  /**
   * Creates an instance of SDExternalUserApplicationStatus.
   * @param {*} json
   * @memberof SDExternalUserApplicationStatus
   */
  constructor(json = null) {
    if (json) {
      // string
      this.applicationFormID = json.applicationFormID;

      // boolean
      this.isApplicationInProgress = json.isApplicationInProgress;
    }
  }
}

/**
 * Models the SDUserApplicationInfo
 *
 * @class SDUserApplicationInfo
 */
class SDUserApplicationInfo {
  /**
   * Creates an instance of SDUserApplicationInfo.
   * @param {*} json
   * @memberof SDUserApplicationInfo
   */
  constructor(json = null) {
    if (json) {
      // string
      this.intakeApplicationID = json.intakeApplicationID;

      // string
      this.scriptExecutionID = json.scriptExecutionID;

      // string
      this.applicationType = json.applicationType;

      // string
      this.applicationStatus = json.applicationStatus;
    }
  }
}

/**
 * Models the SDUserApplicationInfoDtls
 *
 * @class SDUserApplicationInfoDtls
 */
class SDUserApplicationInfoDtls {
  /**
   * Creates an instance of SDUserApplicationInfoDtls.
   * @param {*} json
   * @memberof SDUserApplicationInfoDtls
   */
  constructor(json = null) {
    if (json) {
      // array - SDUserApplicationInfo
      if (json.dtls) {
        this.dtls = json.dtls.map(object => new SDUserApplicationInfo(object));
      } else if (json.constructor === Array) {
        this.dtls = json.map(object => new SDUserApplicationInfo(object));
      }
    }
  }
}

export default {
  SDExternalUserApplicationStatus,

  SDUserApplicationInfo,

  SDUserApplicationInfoDtls,
};
